'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getKey = require('../utils/getKey');

var _getKey2 = _interopRequireDefault(_getKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLineType = function getLineType(isSameSubsector) {
  if (isSameSubsector) {
    return 'solidline';
  }

  return 'dashedline';
};

var getOffset = function getOffset(comp) {
  if (comp) {
    var _comp$getBoundingClie = comp.getBoundingClientRect(),
        top = _comp$getBoundingClie.top,
        left = _comp$getBoundingClie.left,
        right = _comp$getBoundingClie.right;

    return {
      top: top,
      left: left,
      right: right
    };
  }

  return {
    top: 0,
    left: 0
  };
};

var getPosition = function getPosition(connection, type, positions, container) {
  var _connection$type = connection[type],
      level = _connection$type.level,
      column = _connection$type.column,
      index = _connection$type.index;

  var offset = getOffset(container);
  var key = (0, _getKey2.default)(level, column, index);
  var connectionPos = positions[key];
  if (connectionPos) {
    var left = connectionPos.left,
        top = connectionPos.top,
        height = connectionPos.height,
        width = connectionPos.width;


    var y = top + height / 2;

    if (type === 'from') {
      //const x = (right / 3 * 1) + width;
      var _x = left - offset.left + width;
      //console.log(connectionPos);
      //console.log(x, left - offset.left + width, right, width);
      return {
        x: _x,
        y: y
      };
    }

    var x = left - offset.left;
    //console.log('to', left, offset.left, x);
    return {
      x: x,
      y: y
    };
  }

  return {
    x: null,
    y: null
  };
};

var Connections = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Connections, _Component);

  function Connections() {
    (0, _classCallCheck3.default)(this, Connections);
    return (0, _possibleConstructorReturn3.default)(this, (Connections.__proto__ || (0, _getPrototypeOf2.default)(Connections)).apply(this, arguments));
  }

  (0, _createClass3.default)(Connections, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          connections = _props.connections,
          positions = _props.positions;


      var svgStyle = {
        display: 'block'
      };

      var onNextFrame = function onNextFrame(callback) {
        setTimeout(function () {
          window.requestAnimationFrame(callback);
        });
      };

      return _react2.default.createElement(
        'svg',
        {
          style: svgStyle,
          ref: function ref(c) {
            if (!_this2.component && c) {
              onNextFrame(function () {
                _this2.forceUpdate();
              });
              _this2.component = c;
            }
          }
        },
        connections.map(function (connection, key) {
          var from = getPosition(connection, 'from', positions, _this2.component);
          var to = getPosition(connection, 'to', positions, _this2.component);
          if (from && to && from.x && to.x) {
            var className = [getLineType(connection.isSameSubsector), 'line'].join(' ');

            return _react2.default.createElement('line', {
              key: key,
              className: className,
              x1: from.x,
              y1: from.y,
              x2: to.x,
              y2: to.y
            });
          }

          return _react2.default.createElement('line', {
            key: key
          });
        })
      );
    }
  }]);
  return Connections;
}(_react.Component), _class.propTypes = {
  connections: _react.PropTypes.array,
  positions: _react.PropTypes.object
}, _temp);
exports.default = Connections;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/components/Connections.jsx
// module id = 1171
// module chunks = 0